module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("CAPITOLO PRIMO")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("“A")]), _vm._v("my, aspetta!” Il mio")]), _vm._v(" nome è un singhiozzo soffocato sulle labbra di Janice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Voglio essere sordo ad esso. Faccio finta di essere sordo, aprendo l’armadio per trovare la mia valigia. Non posso più restare in questo appartamento, non sapendo quello che so ora. Essere ignoranti era una gioia, anche se c’era sempre il minimo accenno di sospetto in fondo alla mia mente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non ci sono molti Dom aL Flesh. Il buon senso avrebbe dovuto dirmi che Janice sarebbe finita con Lucian. La parte di me che credeva davvero che lei si prendesse cura di me come un’amica e che mi amava, ha cercato di fingere che non fosse possibile che mi facessero questo. Era un pio desiderio però. La realtà è crudele. Tutto è stato crudele nel mio mondo ultimamente. Perché dovrebbe essere diverso?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Le parole di maledizione indugiano sulla punta della mia lingua. Voglio dire a Janice di andare a farsi fottere, ma rimango in silenzio. L’obiettivo è essere più grande di lei in questo momento. Più grande di entrambi. Raccoglierò le mie cose e me ne andrò e non parlerò mai più con nessuno dei due. Questo è il modo migliore per gestire questo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non abbiamo fatto niente”. Janice si appoggia allo stipite della porta della mia camera da letto, le lacrime che le rigano il viso a torrenti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Oh, non l’hai fatto? Veramente? Quei segni sul tuo corpo mi dicono il contrario.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi piacerebbe prendermi il mio tempo per fare le valigie, ma la disperazione sta prendendo il sopravvento su di me. So che Janice non mi lascerà in pace. Mi seguirà come un cucciolo, piangendo e piagnucolando e implorandomi di perdonarla. Il silenzio è la punizione migliore. Beh, accanto alla mia assenza permanente dalla sua vita.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ci siamo baciati. Non mi ha toccato. Abbiamo appena girato la scena insieme”. Audacemente fa un passo nella mia stanza, in piedi tra me e il mio comò. La spingo oltre, praticamente facendola cadere prima di aprire il mio cassetto del comò in alto, afferrando due manciate di reggiseni e biancheria intima e tornando a infilarli disordinatamente nella mia valigia. “Dovete credermi. Sapevo che era sbagliato, ma...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Ma cosa? Lo volevi così tanto che hai smesso di preoccupartene. So com’è. È affascinante. Ottiene ciò che vuole. Sempre. Voi due vi siete segretamente desiderati l’un l’altro dalla prima volta che vi siete incontrati. Siate felici. Ora potete avere l’un l’altro. Non sarò più d’intralcio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Chiudo la valigia, rendendomi conto che sto lasciando più di una mezza dozzina di cose di cui ho bisogno. Non mi interessa più però. Devo uscire di qui prima di scattare. Quel punto è così vicino. Mi sento come un elastico avvolto troppo stretto. È solo questione di tempo prima che io rompa e distrugga tutto ciò che mi circonda.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non mi preoccupo nemmeno di cambiarmi i vestiti. Mi infilo semplicemente un paio di infradito, prendo la valigia e le chiavi e mi dirigo verso la porta. Tornerò a prendere il resto della mia roba più tardi, dopo aver avuto il tempo di rinfrescarmi, ogni volta che saprò che Janice non sarà a casa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Per favore, Amy, non andartene.” Janice mi stringe il braccio, ma lo tiro via da lei. “Non ho mai avuto intenzione di farti del male.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La tensione nella mia mascella ha raggiunto un livello insormontabile quando raggiungo la porta d’ingresso. Ho stretto i denti così forte che sono sorpreso che non si siano frantumati. La mia mente mi sta urlando di tenere la bocca chiusa. Vuole che rompa il mio silenzio. Se lo faccio, sento che in qualche modo vincerà. Non posso farne a meno però.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi volto verso di lei, l’odio appiccicato sul mio viso come una maschera oscura. “Però mi hai fatto male. Mi hai ferito a un livello che non avrei mai immaginato di poter essere ferito, e "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("non ")]), _vm._v("te lo perdonerò "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mai ")]), _vm._v("“.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("* * *")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")]), _vm._v("e mie forze svaniscono")]), _vm._v(" quando esco dal parcheggio del complesso di appartamenti, le gomme che stridono. Sono un disastro di singhiozzi devastanti fino a casa dei miei genitori. Il mio cuore si sente spezzato in modo irreparabile. È una sensazione diversa da qualsiasi cosa mi abbia fatto passare Lucian prima. Il dolore è su più livelli come se il mio cuore fosse fatto di strati di vetro e qualcuno avesse preso un martello su ognuno individualmente. Ho perso l’uomo che amo e il mio migliore amico in una notte. Sembra che non ci sia molto da perdere. Tutto quello che ho ora sono il lavoro, Derrick e i miei genitori. E le cose al lavoro sono traballanti nella migliore delle ipotesi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So che non mi sentirò abbastanza bene per andare a lavorare domani. Speriamo che non importi. Non è che ci sarà comunque qualcosa da fare per me. Tyra sarà probabilmente ancora arrabbiata per il fatto che Lucian abbia terminato il suo contratto di interior design, ma non so se questo renderà le cose migliori o peggiori che non mostro. Non sono sicuro che sia davvero importante in questo momento. Dubito che verrò licenziato, quindi mi occuperò di tutte le conseguenze che richiederanno cause quando sarà il momento. Non ha senso che io vada a lavorare se rimarrò solo un pasticcio che tira su col naso e piagnucola tutto il giorno. E lo sarei sicuramente. Lucian ha ufficialmente riempito la sua “quota di far piangere Amy” per la settimana, come la chiamerebbe Derrick. L’ha riempito per l’ultima volta. Completato al massimo scopando con Janice. Buon Dio, li odio entrambi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mia madre mi saluta alla porta con un abbraccio. Piango e piango e piango. Anche se continua a chiedere cosa c’è che non va, non posso rispondere. Sono troppo stanco per parlarne adesso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non stasera,” dico debolmente mentre mi allontano da lei. “Voglio solo andare a letto e dimenticare oggi.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Per fortuna, lei non curiosa. Mia madre è brava così, sa quando non spingermi. Inoltre, si sta facendo tardi. Mio padre è già andato a letto. Non è qualcosa su cui vale la pena discutere in famiglia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi segue nella mia vecchia camera da letto, che è stata trasformata in una camera degli ospiti dopo che mi sono trasferita, mi bacia sulla fronte e mi lascia solo con i miei demoni. Per alcuni secondi, resto in piedi sulla soglia, guardandomi intorno, chiedendomi come le cose siano andate così male. È colpa di Lucian, ovviamente. O forse è di Janice. Se non avessi mai incontrato Lucian, niente di tutto questo sarebbe successo. Ma se Janice non mi avesse introdotto nello stile di vita, non l’avrei mai incontrato.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sicuramente si appartengono, penso con un profondo sospiro prima di chiudere la porta dietro di me, posare la valigia, togliermi le infradito e strisciare nel letto. Il profumo delle lenzuola è confortante. Profuma di casa. Ma niente potrà lenire il dolore nel mio cuore. Forse ora sono danneggiato quanto Lucian, per non essere mai più guarito. È un pensiero sconcertante e uno che mi fa piangere fino a tarda notte.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La mattina dopo mi sveglio e chiamo al lavoro. Entrambi i miei genitori hanno un lavoro, quindi ho la casa tutta per me. Mi siedo davanti alla televisione, mangio una marca di cereali praticamente insapore, e mi metto a stufare. In qualche modo, durante la notte, il mio dolore si è trasformato in risentimento. Beh, a dire il vero, Janice e Lucian mi sono risentita nel momento in cui ho scoperto che erano stati insieme. Ma sento che se la stanno cavando entrambi facilmente. Lucian più di Janice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il senso di ingiustizia è schiacciante. Ha incasinato le mie amicizie, ha minacciato il mio lavoro e mi ha spezzato il cuore. Scomparire con calma e lasciarlo passare liscia sembra sbagliato. Quel pensiero è amplificato guardando un sacco di Lifetime Movie Network. Non capirò mai perché un canale per donne ha un sacco di programmi con donne tradite, picchiate, uccise e violentate. Dov’è la giustizia nel mondo? Come possono gli uomini farla franca così tanto, eppure le donne non riescono nemmeno a crescere una spina dorsale la maggior parte del tempo senza affrontare un qualche tipo di contraccolpo a causa di ciò? Il pensiero mi fa ribollire. Ancora peggio, mi fa tramare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lucian è al lavoro in questo momento. Sarebbe il momento perfetto per... cosa? Fai irruzione nella sua casa e distruggi la sua preziosa prigione. Sembra assolutamente adorabile. So che ha migliaia di dollari di attrezzature lì dentro. Ma non vale la pena finire in galera. E so che la sua casa ha un sistema di sicurezza. Tutto quello che probabilmente dovrei fare è bussare a una delle finestre e i poliziotti sarebbero alla sua porta in meno di quindici minuti. È sempre un grosso problema quando qualcuno irrompe nella casa di un ricco.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Segna quel pensiero dalla mia lista di possibilità di vendetta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lucian ha detto che va al lavoro quasi tutti i giorni. Potrei andare al suo studio, trovare l’auto più bella nel parcheggio e andare in città con una mazza da baseball. Non mi ci sarebbe voluto tanto tempo. Ma non ho idea di cosa guidi e, con la mia fortuna, finirei per prendere di mira accidentalmente l’auto di qualche celebrità e finirei comunque in prigione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Neanche una buona idea.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mi accascio contro il divano, stropicciando la faccia davanti alla televisione. Se solo questa roba fosse così facile come la fanno sembrare nei film. Perché vendicarsi deve essere così difficile? Tutto quello che voglio è un po’ di punizione per il mio dolore e la mia sofferenza, ma non voglio doverne affrontare le conseguenze. È così tanto da chiedere?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lo spettacolo che sto guardando taglia la pubblicità. Fisso la televisione con sguardo assente, imbronciato internamente alla realizzazione che non c’è assolutamente niente che io possa fare per vendicarmi di Lucian. Ha vinto, come sempre. Stronzo del cazzo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma poi sullo schermo lampeggia una pubblicità per Home Depot. Sono così perso nei miei pensieri che praticamente mi manca. A quanto pare, la mia mente sta ancora elaborando le immagini, perché stanno eseguendo uno speciale su un determinato prodotto e nel momento in cui lo vedo, una lampadina si accende istantaneamente nella mia testa. Ora so cosa farò. So come mi vendicherò contro Lucian.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0